import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../../api/API";
import {Link} from "react-router-dom";
import {useProjectId} from "../../ProjectName";
import {ChangesetLink} from "./ChangesetLink";

export function RequestOrigin(props: {
    inventoryRequest: number;
}) {
    const origin = useAsync2(input => api.logistics.getInventoryRequestOrigin(input), {id: props.inventoryRequest}, [props.inventoryRequest]);
    const projectId = useProjectId();

    if(!origin.result) return origin.LoadingOrErrorElement;

    const cs = origin.result.changeset;
    const fc = origin.result.freeformChange;
    const removedBy = origin.result.removedByChangeset;

    return (
        <>
            {!cs && !fc && <div>No linked change</div>}
            {(cs || fc) && <div>
                Created by{" "}
                {cs && <ChangesetLink projectId={projectId} changeset={cs} />}
                {cs && fc && " / "}
                {fc && <Link to={`/project/${projectId}/shop-drawing/changes/ch/${fc.id}`}>
                    Change {fc.name}
                </Link>}
            </div>}
            {removedBy && <div>
                Removed by <ChangesetLink projectId={projectId} changeset={removedBy} />
            </div>}
        </>
    )
}
